import { Page, Tabs } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { TemplateTypes } from 'apis/templates';
import { useAppNavigate } from 'utils/url/useAppNavigate';

export const TEMPLATE_NAMES: Record<
  Exclude<TemplateTypes, 'email_signature'>,
  string
> = {
  quick_response: 'Quick response',
  email_auto_reply: 'Auto reply',
};

const tabsDefinition = [
  {
    label: TEMPLATE_NAMES.quick_response,
    id: 'quick_response',
  },
  {
    label: TEMPLATE_NAMES.email_auto_reply,
    id: 'email_auto_reply',
  },
];

export const SettingsTemplatesView = (): JSX.Element => {
  const navigate = useAppNavigate();
  const [selectedTab, setSelectedTab] = useState(tabsDefinition[0].id);

  const handleTabChange = (tab: string) => {
    if (tab === tabsDefinition[0].id) {
      navigate({ path: '/settings/templates/quick-response' });
    } else {
      navigate({ path: `/settings/templates/auto-reply` });
    }
    setSelectedTab(tab);

    ampli.settingsTemplatesTabClicked({
      tab: TEMPLATE_NAMES[tab],
    });
  };

  return (
    <Page>
      <Page.Head title="Templates" />

      <Page.Tabs>
        <Tabs
          selectedId={selectedTab}
          tabs={tabsDefinition}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
